import { useRef, useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useLocation, redirect } from "react-router-dom";
import "./Login.css";
import Logo from "../../assets/images/logosimple.svg";
import axios from "../../api/axios";

const LOGIN_URL = "/auth";

const Login = () => {
  // HOOKS
  const { setAuth, persist, setPersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const userRef = useRef();
  const errRef = useRef();

  // STATES
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");

  // On load, give focus to userRef
  useEffect(() => {
    userRef.current.focus();
  }, []);

  // Reset error msg to blank when user or pwd change.
  useEffect(() => {
    setErrMsg("");
  }, [user, pwd]);

  // Toggle checkmark in 'Trust this device' button. Trust this device will allow to stay logged in.
  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  // Store 'Trusted Device' decision into localStorage
  useEffect(() => {
    localStorage.setItem("WGappPersist", persist);
  }, [persist]);

  // Handle Login submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(LOGIN_URL, JSON.stringify({ user, pwd }), {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      //   console.log(response?.data);
      const accessToken = response?.data?.accessToken;
      const role = response?.data?.role;
      const name = response?.data?.name;
      const userCode = response?.data?.userCode;
      const userID = response?.data?.userID;
      setAuth({ name, userCode, role, accessToken, userID });
      setUser("");
      setPwd("");

      // navigate to last visited location before logged out. If no previous location then navigate to home.
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
      //   setSuccess(true);
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg("Login Failed");
      }
      errRef.current.focus();
    }
  };

  return (
    <section className='wrapper'>
      <div className='login'>
        <img src={Logo} alt='' className='login-logo' />
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live='assertive'>
          {errMsg}
        </p>
        <h1>Sign In</h1>
        <form onSubmit={handleSubmit}>
          <label htmlFor='username'>Username:</label>
          <input
            type='text'
            id='username'
            ref={userRef}
            autoComplete='off'
            onChange={(e) => setUser(e.target.value)}
            value={user}
            required
          />

          <label htmlFor='password'>Password:</label>
          <input type='password' id='password' onChange={(e) => setPwd(e.target.value)} value={pwd} required />
          <button>Sign In</button>
          <div className='trustedcheck'>
            <input type='checkbox' id='persist' onChange={togglePersist} checked={persist} />
            <label htmlFor='persist'>Trust This Device</label>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Login;
